// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async fetchSystemTypesList(ctx){
        console.log('fetchSystemTypesList')
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/system-types`, config);
            ctx.commit('updateSystemTypesList', response.data) ;
        } catch (error) {
            return error;
        }
    },
};
